import * as urls from '../../config'
import axios from 'axios'

export default {
  getEditais (unidade, categoria, perPage, page) {
    let service = urls.WP_URL + 'documentos-por-categoria/' + categoria + '/' + unidade + '?per_page=' + perPage + '&page=' + page
    return axios.get(service)
      .then(response => {
        return response
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDocumento (id) {
    let service = urls.WP_URL + 'categoria_documento/' + id
    return axios.get(service)
      .then(response => {
        return response
      })
      .catch(error => {
        console.log(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/api/dcom/EditaisService.js